import './style.css'
import { NavLink } from 'react-router-dom'

const Footer = () => (
    <div className="footer">
        <ul className="footer__group">
            <li className="footer__group-header">Полезные штуки</li>
            <li className="footer__group-item">
                <a target="_blank" rel="noreferrer" href="https://docs.google.com/spreadsheets/d/1iRJMHf6tsYLcPds-YU1tBuSU72eygfai2ZvCLRUc42Y/edit#gid=0">Шеринг вещей</a>
            </li>
            <li className="footer__group-item">
                <NavLink exact to="/discounts" activeClassName="menu-item_active">Скидки</NavLink>
            </li>
            <li className="footer__group-item">
                <NavLink to='/stat' className="nav__menu-item" activeClassName="menu-item_active">Статистика</NavLink>
            </li>
        </ul>
        {/* <ul className="footer__group">
            <li className="footer__group-header">В разработке</li>
            <li className="footer__group-item">
                <NavLink to='/recommendation' className="nav__menu-item" activeClassName="menu-item_active">Рекомендации</NavLink>
            </li>
        </ul> */}
        <ul className="footer__group">
            <li className="footer__group-header">Быр-быр-быр</li>
            <li className="footer__group-item">
                <a target="_blank" rel="noreferrer" href="https://www.notion.so/ded764aca5814dbc83c1ce14e60ae0f8">Ноушн</a>
            </li>
        </ul>
    </div>
)

export default Footer
